import React from "react";
import SectionTitle from "../../../components/sectionTitle";
import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function CustomerEkycBlank({
  classes: {},
  onClickHandler,
  onClose,
  modal,
  modalKey = "open",
}) {
  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.open}
      maxWidth={"md"}
    >
      <DialogTitle id="simple-dialog-title">
        <SectionTitle title={"e-KYC Response"} />
      </DialogTitle>
      <Box m={1}>
        <Box p={1}>
          <Typography variant="caption">
            Sorry we are unable to fetch your details, please try again.
          </Typography>
        </Box>
        <Box mt={3}>
          <Button
            type={"button"}
            variant={"contained"}
            color={"primary"}
            size={"small"}
            onClick={onClickHandler}
            fullWidth
          >
            Retry
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomerEkycBlank);
